import { EventEmitter, NgZone } from '@angular/core';
import { EDIT_TALKING_POINTS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "../../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../../../ycharts/static/ts/features/components/modals/talking-point-text-edit-modal/talking-point-text-edit-modal.component";
import * as i6 from "../../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ "show": a0 });
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ "text-blue": a0 });
function TalkingPointItemComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Reorder")("tooltipPlacement", "bottom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-reorder-up");
} }
function TalkingPointItemComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function TalkingPointItemComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.remove.emit(ctx_r2.talkingPoint.talkingPoint.id)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Remove")("tooltipPlacement", "bottom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-remove-circle");
} }
function TalkingPointItemComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function TalkingPointItemComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.add.emit(ctx_r2.talkingPoint.talkingPoint.id)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipTitle", "Add Talking Point")("disabled", ctx_r2.maxSelected)("tooltipPlacement", "bottom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2, !ctx_r2.maxSelected))("name", "icon-add-circle");
} }
function TalkingPointItemComponent_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function TalkingPointItemComponent_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); i0.ɵɵnextContext(); const talkingPointTextEditModal_r6 = i0.ɵɵreference(16); return i0.ɵɵresetView(talkingPointTextEditModal_r6.openModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
} }
/**
 * Talking Point Item Component
 *
 * Used for displaying a talking point item in a list in the Edit Talking Points Modal
 *
 * Input Properties:
 *  talkingPoint: object with Talking Point data and if it's UI item is expanded.
 *  defaultText: string of the proposal text saved in the backend for the Talking Point.
 *  maxSelected: boolean to show if the max number of Talking Points has been selected.
 *  selected: boolean to show if the current Talking Point is in the selected list.
 *
 * Output Properties:
 *  add: emits the Talking Point id when it's being added to the selected list.
 *  remove: emits the Talking Point id when it's being removed from the selected list.
 *
 */
export class TalkingPointItemComponent {
    constructor(ngZone, featureService) {
        this.ngZone = ngZone;
        this.featureService = featureService;
        this.class = 'plate-container';
        this.add = new EventEmitter();
        this.remove = new EventEmitter();
        this.hasEditFeature = this.featureService.userHasFeatures([EDIT_TALKING_POINTS_FEATURE]);
    }
    ngOnInit() {
        this.talkingPointTextEditModalTitle = `Edit ${this.talkingPoint.talkingPoint.name} Text`;
    }
    textSaved(newText) {
        this.talkingPoint.talkingPoint.proposal_text = newText;
    }
}
TalkingPointItemComponent.ɵfac = function TalkingPointItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointItemComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.FeatureService)); };
TalkingPointItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TalkingPointItemComponent, selectors: [["ycn-talking-point-item"]], hostVars: 2, hostBindings: function TalkingPointItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassMap(ctx.class);
    } }, inputs: { talkingPoint: "talkingPoint", defaultText: "defaultText", maxSelected: "maxSelected", selected: "selected", includeBenchmark: "includeBenchmark", securities: "securities", reportOrientation: "reportOrientation" }, outputs: { add: "add", remove: "remove" }, standalone: false, decls: 17, vars: 19, consts: [["talkingPointTextEditModal", ""], [1, "plate", "plate-collapsible", "plate-white"], [1, "plate-header"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-toggler", "show", 3, "click", "ngClass"], ["ycnIcon", "", 1, "icon-collapse", "fill-current", "text-gray-70", 3, "name"], [1, "plate-title", "align-items-center", "text-bold", "ng-binding", 3, "textContent"], [1, "plate-controls"], ["class", "btn btn-xs btn-circle btn-transparent btn-lightgray plate-control btn-reorder", "ycnTooltip", "", 3, "tooltipTitle", "tooltipPlacement", 4, "ngIf"], ["class", "btn btn-xs btn-circle btn-transparent plate-control", "ycnTooltip", "", 3, "tooltipTitle", "tooltipPlacement", "click", 4, "ngIf"], ["class", "btn btn-xs btn-circle btn-transparent plate-control", "data-test-id", "add-talking-point-button", "ycnTooltip", "", "ycnDisabled", "", 3, "tooltipTitle", "disabled", "tooltipPlacement", "click", 4, "ngIf"], [1, "plate-content", "collapse", "show", 3, "ngClass"], [1, "d-flex"], [3, "innerHTML"], [1, "flex-none", "align-self-end"], ["class", "btn btn-xs btn-circle btn-transparent btn-lightgray plate-control btn-edit", 3, "click", 4, "ngIf"], [3, "textSaved", "title", "talkingPoint", "defaultText", "securities", "includeBenchmark", "reportOrientation"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-reorder", 3, "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", 1, "icon-reorder-up", 3, "name"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "plate-control", 3, "click", "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", 1, "icon-remove-circle", "fill-current", "text-blue", "poiners-events-none", 3, "name"], ["data-test-id", "add-talking-point-button", "ycnTooltip", "", "ycnDisabled", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "plate-control", 3, "click", "tooltipTitle", "disabled", "tooltipPlacement"], ["ycnIcon", "", 1, "icon-add-circle", "fill-current", "poiners-events-none", 3, "ngClass", "name"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-edit", 3, "click"], ["ycnIcon", "", 1, "icon-edit", 3, "name"]], template: function TalkingPointItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "button", 3);
        i0.ɵɵlistener("click", function TalkingPointItemComponent_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.talkingPoint.showMore = !ctx.talkingPoint.showMore); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(3, "svg", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(4, "div", 5);
        i0.ɵɵelementStart(5, "div", 6);
        i0.ɵɵtemplate(6, TalkingPointItemComponent_button_6_Template, 2, 3, "button", 7)(7, TalkingPointItemComponent_button_7_Template, 2, 3, "button", 8)(8, TalkingPointItemComponent_button_8_Template, 2, 7, "button", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 10)(10, "div", 11)(11, "div");
        i0.ɵɵelement(12, "p", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 13);
        i0.ɵɵtemplate(14, TalkingPointItemComponent_button_14_Template, 2, 1, "button", 14);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(15, "ycn-talking-point-text-edit-modal", 15, 0);
        i0.ɵɵlistener("textSaved", function TalkingPointItemComponent_Template_ycn_talking_point_text_edit_modal_textSaved_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.textSaved($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0, ctx.talkingPoint.showMore));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-collapse");
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.talkingPoint.talkingPoint.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selected);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selected);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.selected);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1, ctx.talkingPoint.showMore));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", ctx.talkingPoint.talkingPoint.proposal_text, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasEditFeature && ctx.selected);
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", ctx.talkingPointTextEditModalTitle)("talkingPoint", ctx.talkingPoint.talkingPoint)("defaultText", ctx.defaultText)("securities", ctx.securities)("includeBenchmark", ctx.includeBenchmark)("reportOrientation", ctx.reportOrientation);
    } }, dependencies: [i2.NgClass, i2.NgIf, i3.DisabledDirective, i4.IconDirective, i5.TalkingPointTextEditModalComponent, i6.TooltipDirective], encapsulation: 2 });
